// this is used to create scrollbars on windows devices like the ones from apple devices
// import * as Ps from "perfect-scrollbar";
import "perfect-scrollbar/dist/css/perfect-scrollbar.min.css";

import React, { Component } from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { compose, graphql } from "react-apollo";

import CompanySwitcher from "../../components/Company/CompanySwitcherAlert/CompanySwitcher";
import Header from "../../components/Header/Header";
import MainContext from "../../containers/Contexts/MainContext";
// react component that creates notifications (like some alerts with messages)
import NotificationSystem from "react-notification-system";
import { PropsRoute } from "react-router-with-props";
import Queries from "../../queries/queries2";
import Sidebar from "../../components/Sidebar/Sidebar";
import Spinner from "../../elements/Spinner/Spinner";
// dinamically create dashboard routes
import dashRoutes from "../../routes/dash";
// style for notifications
import { style } from "../../variables/Variables";

// import Footer from "../../components/Footer/Footer.jsx";

// const MainContext = React.createContext({
//   currencies: undefined
// });

class Dash extends Component {
  constructor(props) {
    // console.log("Dash constructor");
    super(props);
    this.handleNotificationClick = this.handleNotificationClick.bind(this);
    this.sendNotification = this.sendNotification.bind(this);
    this.handleMinimizeSidebar = this.handleMinimizeSidebar.bind(this);
    // this.notificationRef = React.createRef();

    this.state = {
      // _notificationSystem: null,
      companySwitcherView: false,
      navExpanded: true
    };
  }
  componentDidMount() {
    // console.log("Dash componentDidMount", this.refs);

    // dont setstate here, we cant afford a redraw
    // this.setState({ _notificationSystem: this.refs.notificationSystem });
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      // Ps.initialize(this.refs.mainPanel, {
      //   wheelSpeed: 2,
      //   suppressScrollX: true
      // });
    }
    if (document.documentElement.className.indexOf("nav-open") !== -1) {
      document.documentElement.classList.toggle("nav-open");
    }

    if (!this.props.companyId) {
      this.props.history.push("/companies");
    }
  }

  // function that shows/hides notifications - it was put here, because the wrapper div has to be outside the main-panel class div
  sendNotification(notificationContent) {
    notificationContent.position = notificationContent.position ? notificationContent.position : "tc";
    notificationContent.autoDismiss = notificationContent.autoDismiss ? notificationContent.autoDismiss : "3";
    this.refs.notificationSystem.addNotification(notificationContent);
    // this.state._notificationSystem.addNotification(notificationContent);
  }

  shouldComponentUpdate(nextProps, nextState) {
    // console.log("73 - state/nextState=", this.state, nextState);
    return (this.state.navExpanded === nextState.navExpanded);
  }


  handleMinimizeSidebar() {
    if (this.state.navExpanded) {
      document.body.classList.add("sidebar-mini");
      this.setState({ navExpanded: false });
    } else {
      document.body.classList.remove("sidebar-mini");
      this.setState({ navExpanded: true });
    }
  }

  handleNotificationClick(
    position = "tr",
    content = undefined,
    level = undefined,
    icon = undefined
  ) {
    var level_;
    if (level) level_ = level;
    else {
      var color = Math.floor(Math.random() * 4 + 1);
      switch (color) {
        case 1:
          level_ = "success";
          break;
        case 2:
          level_ = "warning";
          break;
        case 3:
          level_ = "error";
          break;
        case 4:
          level_ = "info";
          break;
        default:
          break;
      }
    }

    var content_;
    if (content) {
      content_ = content;
    } else
      content_ = (
        <div>
          Welcome to <b>Netwips</b>.
        </div>
      );

    var icon_;
    if (icon) icon_ = <span data-notify="icon" className={icon} />;
    else icon_ = <span data-notify="icon" className="pe-7s-gift" />;

    this.state._notificationSystem.addNotification({
      title: icon_,
      message: content_,
      level: level_,
      position: position,
      autoDismiss: 3
    });
  }

  onCompanySwitcherHiddenHandler = () => {
    this.setState({ companySwitcherView: false });
  };

  showCompanySwitcher = () => {
    console.log("showCompanySwitcher");
    this.setState({ companySwitcherView: true });
  };

  // function that creates perfect scroll bar for windows users (it creates a scrollbar that looks like the one from apple devices)
  isMac() {
    let bool = false;
    if (
      navigator.platform.toUpperCase().indexOf("MAC") >= 0 ||
      navigator.platform.toUpperCase().indexOf("IPAD") >= 0
    ) {
      bool = true;
    }
    return bool;
  }
  componentDidUpdate(e) {
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      // setTimeout(() => {
      //   Ps.update(this.refs.mainPanel);
      // }, 350);
    }
    if (e.history.action === "PUSH") {
      if (this.refs.mainPanel) this.refs.mainPanel.scrollTop = 0;
    }
  }
  // componentDidMount() {
  //   if (document.documentElement.className.indexOf("nav-open") !== -1) {
  //     document.documentElement.classList.toggle("nav-open");
  //   }
  // }
  render() {
    // console.log("render Dash location=", this.props.location.pathname);
    // console.log("dashboard props", this.props);

    if (!this.props.data.currencies) {
      return <Spinner size="lg" fullScreen />;
    }

    // console.log("182 - this.props=", this.props);
    // console.log("184 - this.props.companyOptions=", JSON.parse(this.props.companyOptions));

    const defaultMenu = this.props.companyOptions ? JSON.parse(this.props.companyOptions).default : true;
    const odooMenu = this.props.companyOptions ? JSON.parse(this.props.companyOptions).odoo : false;

    return (
      <div className="wrapper">
        <MainContext.Provider
          value={{ currencies: this.props.data.currencies }}>
          <NotificationSystem ref="notificationSystem" style={style} />
          {/* <NotificationSystem ref={this.notificationRef} style={style} /> */}
          <CompanySwitcher
            show={this.state.companySwitcherView}
            onHidden={() => this.onCompanySwitcherHiddenHandler()}
            showCompanySwitcher={() => this.showCompanySwitcher()}
            userId={this.props.userId}
          />
          <Sidebar
            {...this.props}
            handleMinimizeSidebar={this.handleMinimizeSidebar}
          />
          <div
            className={
              "main-panel" +
              (this.props.location.pathname === "/maps/full-screen-maps"
                ? " main-panel-maps"
                : "")
            }
            ref="mainPanel">
            <div className="visible-sm visible-xs">
              <Header
                {...this.props}
                onCompanySwitcherHiddenHandler={() =>
                  this.onCompanySwitcherHiddenHandler()
                }
                showCompanySwitcher={() => this.showCompanySwitcher()}
              />
            </div>
            <Switch>
              {dashRoutes(this.props).map((prop, key) => {
                if (prop.collapse) {
                  return prop.views.map((prop, key) => {
                    if (prop.name === "Notifications") {
                      return (
                        <Route
                          name={prop.name}
                          path={prop.path}
                          key={key}
                          render={routeProps => (
                            <prop.component
                              {...routeProps}
                              //                            handleClick={this.handleNotificationClick}
                              sendNotification={this.sendNotification}
                            />
                          )}
                        />
                      );
                    } else {
                      return (
                        <PropsRoute
                          name={prop.name}
                          path={prop.path}
                          component={prop.component}
                          key={key}
                          userId={this.props.userId}
                          companyId={this.props.companyId}
                          userTiersId={this.props.userTiersId}
                          role={this.props.role}
                          handleMinimizeSidebar={this.handleMinimizeSidebar}
                          //                      handleClick={this.handleNotificationClick}
                          sendNotification={this.sendNotification}
                          // test={"Youpi1"}
                          defaultMenu={defaultMenu}
                          odooMenu={odooMenu}
                          loggedEmail={this.props.loggedEmail}
                        />
                      );
                    }
                  });
                } else {
                  if (prop.redirect)
                    return (
                      <Redirect from={prop.path} to={prop.pathTo} key={key} />
                    );
                  else {
                    return (
                      <PropsRoute
                        name={prop.name}
                        path={prop.path}
                        component={prop.component}
                        key={key}
                        userId={this.props.userId}
                        companyId={this.props.companyId}
                        userTiersId={this.props.userTiersId}
                        role={this.props.role}
                        sendNotification={this.sendNotification}
                        handleMinimizeSidebar={this.handleMinimizeSidebar}
                        // test={"Youpi2"}
                        defaultMenu={defaultMenu}
                        odooMenu={odooMenu}
                        loggedEmail={this.props.loggedEmail}
                      />
                    );
                  }
                }
              })}
            </Switch>
            {/* <Footer fluid /> */}
          </div>
        </MainContext.Provider>
      </div>
    );
  }
}

// export default Dash;

export default compose(graphql(Queries.GET_CURRENCIES))(withRouter(Dash));
// graphql(Queries.LOGGED_IN_USER_QUERY, { name: 'loggedInUserQuery', options: { fetchPolicy: 'network-only' } }),
